import { r as registerInstance, h, H as Host } from './index-d4808923.js';

const gravityFlagCss = ":host{display:inline-block}img{display:block;height:100%;width:var(--gravity-flag-width, 100%)}";
const GravityFlagStyle0 = gravityFlagCss;

const GravityFlag = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.alt = '';
        this.code = undefined;
        this.loading = 'eager';
    }
    getFlagUrl() {
        if (this.code == 'TW') {
            return ` https://rbds-static.redbull.com/@gravity/foundation/latest/flags/gravity-flag-${this.code}.svg?decache=1`;
        }
        return ` https://rbds-static.redbull.com/@gravity/foundation/latest/flags/gravity-flag-${this.code}.svg`;
    }
    render() {
        return (h(Host, { key: '2efc08995d745d251cc4237e7e033e326d6ab4a8' }, h("img", { key: 'f175eeaa92332d49298043dd873afc8007089f41', src: this.getFlagUrl(), loading: this.loading, alt: this.alt })));
    }
};
GravityFlag.style = GravityFlagStyle0;

export { GravityFlag as gravity_flag };

//# sourceMappingURL=gravity-flag.entry.js.map